<header>
    <h2>Products</h2>

    <div class="right">
        
    </div>
</header>
